// extracted by mini-css-extract-plugin
export var aggregationCell = "_2d-k";
export var aggregationRow = "_2d-j";
export var borderlessSpinnerContainer = "_2d-3";
export var closeIcon = "_2d-c";
export var columnHeaderSurface = "_2d-8";
export var columnHeaderSurfaceDragOverlay = "_2d-s";
export var columnHeaderSurfaceResizing = "_2d-p";
export var contextMenuAnchor = "_2d-1";
export var draggableColumnHeader = "_2d-q";
export var draggableColumnHeaderOverlay = "_2d-r";
export var expandIcon = "_2d-d";
export var expanded = "_2d-e";
export var filterDropdown = "_2d-f";
export var filterDropdownDivider = "_2d-a";
export var filterDropdownHeader = "_2d-i";
export var filterDropdownItem = "_2d-h";
export var filterDropdownModal = "_2d-g _2d-f";
export var filterItem = "_2d-9";
export var normalCellWithAdjustableBorder = "_2d-b";
export var pinButtonContainer = "_2d-l";
export var pinIcon = "_2d-m";
export var pinIconActive = "_2d-n";
export var spinner = "_2d-0";
export var spinnerContainer = "_2d-2";
export var tableContainer = "_2d-4";
export var tableContentDraggingColumns = "_2d-7";
export var tableContentInner = "_2d-6";
export var tableContentWrapper = "_2d-5";
export var viewButtonContainer = "_2d-o";